module.exports = __webpack_public_path__ + "files/SPIADI2019 - Poster GIFAV.b0aea380ed6963f40b11c78ed5a26e03.pdf";